import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {saveCompanyExtCredential} from "../common/api/WebApi";

export default function ManageExtCredential({
                                                type, typeId, credential, show, handleSave, handleClose
                                              }) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);
  const [isNew, setIsNew] = useState(credential?.id);
  const [saving, setSaving] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(credential)
  });

  const handleFormSave = (formData) => {
    setSaving(true);
    let _formData = {...formData};
    _formData.host = 'Twilio';
    _formData.credentialTypeId = typeId;
    saveCompanyExtCredential(_formData).then((resp) => {
      setSaving(false);
      handleSave('close')
    }).catch((err) => {
      setSaving(false);
    })
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'extCredentialForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} {type} Credential</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('authKey', {
                          autoComplete: 'off'
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Auth Key"}
                        autoComplete="off" required
                        className="form-control" id="authKey"
                        label="Auth Key"/>

                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="password"
                        {...register('authToken')}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Auth Token"}
                        autoComplete="off" required
                        className="form-control" id="password"
                        label="Auth Token"/>

                    </div>
                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}